<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-btn color="general" light class="mb-2" @click="newItem">{{
                    $t("language.new")
                  }}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>

            <v-dialog v-model="dialog" max-width="600px" min-height="300px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(save)">
                  <v-card>
                    <v-card-title>
                      {{ $t("language.personaldetail") }}
                    </v-card-title>
                    <v-card-text>
                      <v-tabs>
                        <v-tab>{{ $t("language.officialrecord") }}</v-tab>
                        <v-tab>{{ $t("language.basicinformation") }}</v-tab>
                        <v-tab>{{ $t("language.officehour") }}</v-tab>
                        <v-tab-item>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.deviceid')"
                                  rules="required|numeric"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    :disabled="isEdit"
                                    v-model="vModel.id"
                                    :label="$t('language.deviceid')"
                                    :error-messages="errors[0]"
                                  />
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="vModel.name"
                                    :label="$t('language.name')"
                                    :error-messages="errors[0]"
                                  />
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.emailaddress')"
                                  rules="required|email"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="vModel.user.emailaddress"
                                    :label="$t('language.emailaddress')"
                                    :error-messages="errors[0]"
                                  />
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.designation')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.designationid"
                                    :items="DesignationList"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('language.designation')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.department')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.departmentid"
                                    :items="DepartmentList"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('language.department')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.branch')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.branchid"
                                    :items="BranchList"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('language.branch')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.mode')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.modeid"
                                    :items="ModeList"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('language.mode')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.type')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.typeid"
                                    :items="TypeList"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('language.type')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.rankingorder')"
                                  rules="required|numeric"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="vModel.rankingorder"
                                    :label="$t('language.rankingorder')"
                                    :error-messages="errors[0]"
                                  />
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm12 md4>
                                <ValidationProvider
                                  :name="$t('language.joindate')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="vModel.joindate"
                                    :label="$t('language.joindate')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.status')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.status"
                                    :items="StatusList"
                                    :label="$t('language.status')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex
                                xs12
                                sm12
                                md4
                                v-if="vModel.status != 'Working'"
                              >
                                <ValidationProvider
                                  :name="$t('language.releasedate')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="vModel.releasedate"
                                    :label="$t('language.releasedate')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.role')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.user.roleid"
                                    :items="RoleList"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('language.role')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-switch
                                  v-model="vModel.leaveapprover"
                                  :label="$t('language.leaveapprover')"
                                ></v-switch>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                md4
                                v-if="$store.getters.settings.enablerecommender"
                              >
                                <v-switch
                                  v-model="vModel.leaverecommender"
                                  :label="$t('language.leaverecommender')"
                                ></v-switch>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                md4
                                v-if="$store.getters.settings.enableot"
                              >
                                <v-switch
                                  v-model="vModel.oteligible"
                                  :label="$t('language.oteligible')"
                                ></v-switch>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-tab-item>
                        <v-tab-item>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm12 md4>
                                <ValidationProvider
                                  :name="$t('language.dateofbirth')"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="vModel.dateofbirth"
                                    :label="$t('language.dateofbirth')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.maritalstatus')"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.maritalstatus"
                                    :items="MaritalStatusList"
                                    :label="$t('language.maritalstatus')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <ValidationProvider
                                  :name="$t('language.gender')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="vModel.gender"
                                    :items="GenderList"
                                    :label="$t('language.gender')"
                                    :error-messages="errors[0]"
                                    :clearable="true"
                                  ></v-autocomplete>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="vModel.bloodgroup"
                                  :label="$t('language.bloodgroup')"
                                />
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="vModel.mobilenumber"
                                  :label="$t('language.mobilenumber')"
                                />
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="vModel.permanentaddress"
                                  :label="$t('language.permanentaddress')"
                                />
                              </v-flex>
                              <v-flex xs12 sm6 md4>
                                <v-text-field
                                  v-model="vModel.temporaryaddress"
                                  :label="$t('language.temporaryaddress')"
                                />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card
                            class="mt-2"
                            v-for="officehour in vModel.personalofficehours"
                            :key="officehour.effectivedate"
                          >
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm12 md4>
                                  <ValidationProvider
                                    :name="$t('language.effectivedate')"
                                    :rules="effectivedaterule()"
                                    v-slot="{ errors }"
                                  >
                                    <eng-nep-date-picker
                                      :error-messages="errors[0]"
                                      v-model="officehour.effectivedate"
                                      :label="$t('language.effectivedate')"
                                    ></eng-nep-date-picker>
                                  </ValidationProvider>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <ValidationProvider
                                    :name="$t('language.timein')"
                                    rules="required|time"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      v-model="officehour.timein"
                                      autocomplete="off"
                                      :label="$t('language.timein')"
                                      :error-messages="errors[0]"
                                      @change="calculateWorkingHour(officehour)"
                                    />
                                  </ValidationProvider>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <ValidationProvider
                                    :name="$t('language.timeout')"
                                    rules="required|time"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      v-model="officehour.timeout"
                                      autocomplete="off"
                                      :label="$t('language.timeout')"
                                      :error-messages="errors[0]"
                                      @change="calculateWorkingHour(officehour)"
                                    />
                                  </ValidationProvider>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <ValidationProvider
                                    :name="$t('language.workinghour')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      disabled="disabled"
                                      v-model="officehour.workinghour"
                                      :label="$t('language.workinghour')"
                                      :error-messages="errors[0]"
                                    />
                                  </ValidationProvider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-subheader class="pad0"
                                    >Weekend</v-subheader
                                  >
                                  <v-divider class="mlr0"></v-divider>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.sun"
                                    :label="$t('language.sun')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.mon"
                                    :label="$t('language.mon')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.tue"
                                    :label="$t('language.tue')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.wed"
                                    :label="$t('language.wed')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.thu"
                                    :label="$t('language.thu')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.fri"
                                    :label="$t('language.fri')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-switch
                                    v-model="officehour.personalweekend.sat"
                                    :label="$t('language.sat')"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-subheader class="pad0">
                                    {{ $t("language.exceptionalofficehour") }}
                                    <v-spacer />
                                    <v-btn
                                      text
                                      small
                                      @click="addExceptionalHour(officehour)"
                                    >
                                      <v-icon>add</v-icon>
                                      {{ $t("language.add") }}
                                    </v-btn>
                                  </v-subheader>
                                  <v-divider class="mlr0"></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-simple-table
                                    v-if="
                                      officehour.personalexceptionalofficehours
                                        .length > 0
                                    "
                                  >
                                    <template v-slot:default>
                                      <tbody>
                                        <tr
                                          v-for="item in officehour.personalexceptionalofficehours"
                                          :key="item.weekdayid"
                                        >
                                          <td>
                                            <ValidationProvider
                                              :name="$t('language.weekday')"
                                              rules="required"
                                              v-slot="{ errors }"
                                            >
                                              <v-autocomplete
                                                v-model="item.weekdayid"
                                                :items="weekDayList"
                                                item-text="text"
                                                item-value="value"
                                                :label="$t('language.weekday')"
                                                :error-messages="errors[0]"
                                                :clearable="true"
                                              ></v-autocomplete>
                                            </ValidationProvider>
                                          </td>
                                          <td>
                                            <ValidationProvider
                                              :name="$t('language.timein')"
                                              rules="required|time"
                                              v-slot="{ errors }"
                                            >
                                              <v-text-field
                                                v-model="item.timein"
                                                autocomplete="off"
                                                :label="$t('language.timein')"
                                                :error-messages="errors[0]"
                                                @change="
                                                  calculateWorkingHour(item)
                                                "
                                              />
                                            </ValidationProvider>
                                          </td>
                                          <td>
                                            <ValidationProvider
                                              :name="$t('language.timeout')"
                                              rules="required|time"
                                              v-slot="{ errors }"
                                            >
                                              <v-text-field
                                                v-model="item.timeout"
                                                autocomplete="off"
                                                :label="$t('language.timeout')"
                                                :error-messages="errors[0]"
                                                @change="
                                                  calculateWorkingHour(item)
                                                "
                                              />
                                            </ValidationProvider>
                                          </td>
                                          <td>
                                            <ValidationProvider
                                              :name="$t('language.workinghour')"
                                              rules="required"
                                              v-slot="{ errors }"
                                            >
                                              <v-text-field
                                                disabled="disabled"
                                                v-model="item.workinghour"
                                                :label="
                                                  $t('language.workinghour')
                                                "
                                                :error-messages="errors[0]"
                                              />
                                            </ValidationProvider>
                                          </td>
                                          <td>
                                            <v-icon
                                              small
                                              @click="
                                                removeExceptionalHour(
                                                  officehour,
                                                  item
                                                )
                                              "
                                              >delete</v-icon
                                            >
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-card-actions>
                              <v-spacer />
                              <v-btn
                                small
                                text
                                @click="removeOfficeHour(officehour)"
                              >
                                <v-icon>delete</v-icon>
                                {{ $t("language.delete") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-flex xs12 sm12 md12>
                            <v-subheader class="pad0">
                              <v-spacer />
                              <v-btn small text @click="addOfficeHour">
                                <v-icon>add</v-icon>
                                {{ $t("language.add") }}
                              </v-btn>
                            </v-subheader>
                          </v-flex>
                        </v-tab-item>
                      </v-tabs>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey darken-1" text @click="closedialog">{{
                        $t("language.cancel")
                      }}</v-btn>
                      <v-btn
                        v-if="!isEdit"
                        color="green darken-1"
                        @click="passes(saveandreset)"
                        text
                        type="button"
                        >{{ $t("language.saveandreset") }}</v-btn
                      >
                      <v-btn color="blue darken-1" text type="submit">{{
                        $t("language.save")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-dialog
              v-model="changepassworddialog"
              max-width="300px"
              min-height="300px"
            >
              <ValidationObserver ref="formresetpassword" v-slot="{ passes }">
                <v-form @submit.prevent="passes(changepassword)">
                  <v-card>
                    <v-card-title>
                      {{ $t("language.resetpassword") }}
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <ValidationProvider
                              :name="$t('language.password')"
                              rules="required"
                              v-slot="{ errors }"
                              vid="password"
                            >
                              <v-text-field
                                v-model="changePasswordVModel.password"
                                :label="$t('language.password')"
                                :error-messages="errors[0]"
                                :type="'password'"
                              />
                            </ValidationProvider>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="grey darken-1"
                        text
                        @click="closechangepassworddialog"
                        >{{ $t("language.cancel") }}</v-btn
                      >
                      <v-btn color="blue darken-1" text type="submit">{{
                        $t("language.save")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(filtergrid)" class="mb-5">
                <v-card>
                  <v-expansion-panels v-model="panel" multiple focusable>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("language.filter")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card-text>
                          <v-container grid-list-xl>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.branchid"
                                  :items="BranchList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.branch')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.departmentid"
                                  :items="DepartmentList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.department')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.designationid"
                                  :items="DesignationList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.designation')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.roleid"
                                  :items="RoleList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.role')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.modeid"
                                  :items="ModeList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.mode')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.typeid"
                                  :items="TypeList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.type')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.gender"
                                  :items="GenderList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.gender')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="grid.filter.status"
                                  :items="StatusList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.status')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                  <v-text-field
                                    v-model="grid.filter.name"
                                    :label="$t('language.name')"
                                  />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            dense
                            color="general"
                            class="mr-2"
                            light
                            type="submit"
                            >{{ $t("language.filter") }}</v-btn
                          >
                          <v-btn
                            dense
                            class="mr-2"
                            light
                            @click="resetFilter"
                            >{{ $t("language.clear") }}</v-btn
                          >
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>
              </v-form>
            </ValidationObserver>
            <v-data-table
              :headers="grid.headers"
              :items="grid.body"
              :search="grid.search"
              :options.sync="grid.options"
              :server-items-length="grid.total"
              :loading="grid.loading"
              :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
              class="elevation-2"
            >
              <template v-slot:header.id>
                <span>{{ $t("language.deviceid") }}</span>
              </template>
              <template v-slot:header.name>
                <span>{{ $t("language.name") }}</span>
              </template>
              <template v-slot:header.designation>
                <span>{{ $t("language.designation") }}</span>
              </template>
              <template v-slot:header.branch>
                <span>{{ $t("language.branch") }}</span>
              </template>
              <template v-slot:header.rankingorder>
                <span>{{ $t("language.rankingorder") }}</span>
              </template>
              <template v-slot:header.role>
                <span>{{ $t("language.role") }}</span>
              </template>
              <template v-slot:header.username>
                <span>{{ $t("language.email") }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.id)"
                  >edit</v-icon
                >
                <v-icon
                  small
                  class="mr-2"
                  @click="showchangepassworddialog(item.id)"
                  >vpn_key</v-icon
                >
                <v-icon small @click="deleteItem(item.id)">delete</v-icon>
              </template>
            </v-data-table>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Base from "../../shared/Base.vue";
import EngNepDatePicker from "../../components/shared/EngNepDatePicker";
import TimePicker from "../../components/shared/TimePicker";
import commonservice from "../../shared/common.service";
export default {
  name: "personaldetailview",
  extends: Base,
  components: {
    EngNepDatePicker,
    TimePicker,
  },
  data() {
    return {
      panel: [1],
      DesignationList: [],
      DepartmentList: [],
      BranchList: [],
      ModeList: [],
      TypeList: [],
      RoleList: [],
      StatusList: commonservice.statusList,
      GenderList: [],
      MaritalStatusList: commonservice.maritalStatusList,
      weekDayList: commonservice.weekDayList,
      changePasswordVModel: {},
      changepassworddialog: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/personaldetails/init/list").then((response) => {
      next((p) => {
        p.DesignationList = response.data.designations;
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.ModeList = response.data.modes;
        p.TypeList = response.data.types;
        p.RoleList = response.data.roles;
        p.vModel.branchid=p.BranchList[0].id;
        p.vModel.modeid=p.ModeList[0].id;
        p.vModel.typeid= p.TypeList[0].id;
      });
    });
  },
  created() {
    this.resetFilter();
    this.grid.headers = [
      { value: "id" },
      { value: "name" },
      { value: "designation" },
      { value: "branch" },
      { value: "rankingorder" },
      { value: "role" },
      { value: "username" },
      { value: "action", sortable: false, width: 100 },
    ];
    this.vModel = {
      id: null,
      name: null,
      rankingorder: 10,
      joindate: moment().format("YYYY-MM-DD"),
      status: "Working",
      releasedate: null,
      leaveapprover: false,
      leaverecommender: false,
      oteligible: false,
      dateofbirth: null,
      maritalstatus: null,
      gender: "Male",
      bloodgroup: null,
      mobilenumber: null,
      permanentaddress: null,
      temporaryaddress: null,
      designationid: null,
      departmentid: null,
      branchid: null,
      modeid: null,
      typeid: null,
      user: {
        id: null,
        emailaddress: null,
        roleid: 6,
      },
      personalofficehours: [],
    };
    this.url = "client/personaldetails";

    this.GenderList = commonservice.genderList.filter((item) => {
      return item != "All";
    });
    this.panel = [...Array(1).keys()].map((k, i) => i);
  },
  methods: {
    addOfficeHour() {
      this.vModel.personalofficehours.push({
        id: null,
        timein: null,
        timeout: null,
        workinghour: null,
        effectivedate: null,
        personalweekend: {
          id: null,
          sun: false,
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
        },
        personalexceptionalofficehours: [],
      });
    },
    removeOfficeHour(item) {
      var index = this.vModel.personalofficehours.indexOf(item);
      if (index > -1) this.vModel.personalofficehours.splice(index, 1);
    },
    addExceptionalHour(officehour) {
      officehour.personalexceptionalofficehours.push({
        timein: null,
        timeout: null,
        workinghour: null,
        weekdayid: null,
      });
    },
    removeExceptionalHour(officehour, item) {
      var index = officehour.personalexceptionalofficehours.indexOf(item);
      if (index > -1)
        officehour.personalexceptionalofficehours.splice(index, 1);
    },
    calculateWorkingHour(item) {
      item.workinghour = commonservice.getTimeDifferenceInHour(
        item.timein,
        item.timeout
      );
    },
    resetFilter() {
      this.grid.filter = {
        branchid: null,
        departmentid: null,
        designationid: null,
        roleid: null,
        modeid: null,
        typeid: null,
        gender: null,
        status: null,
        name: null
      };
      this.grid.body = [];
      this.grid.total = 0;
      this.loadGrid();
    },
    resetChangePassword(personaldetailid) {
      this.changePasswordVModel = {
        personaldetailid: personaldetailid,
        password: null,
      };
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.formresetpassword.reset();
        });
      }, 300);
    },
    closechangepassworddialog() {
      if (!this.changepassworddialog) return;
      this.changepassworddialog = false;
      this.resetChangePassword(null);
    },
    showchangepassworddialog(personaldetailid) {
      this.changepassworddialog = true;
      this.resetChangePassword(personaldetailid);
    },
    changepassword() {
      if (this.loading) return;
      this.loading = true;
      axios
        .post(
          "client/personaldetails/change/password",
          this.changePasswordVModel
        )
        .then(
          () => {
            this.$store.dispatch(
              "showSuccessMessage",
              this.$t("language.passwordsetsuccessful")
            );
            this.closechangepassworddialog();
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    },
    processEditData(data){
      data.personalofficehours.forEach(item => {
        if (item.personalweekend == null) {
          item.personalweekend = {
            id: null,
            sun: false,
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false
          }
        }
      });
      return data;
    },
    getResetValues(){
      let model = Object.assign({}, this.initVModel);
      model.id = parseInt(this.vModel.id) + 1;
      model.rankingorder = parseInt(this.vModel.rankingorder) + 1
      model.departmentid = this.vModel.departmentid;
      model.branchid = this.vModel.branchid;
      model.modeid = this.vModel.modeid;
      model.typeid = this.vModel.typeid;
      model.joindate = this.vModel.joindate;
      model.user.emailaddress = null;
      
      return model;
    },
    effectivedaterule() {
      var rule = "required";
      // if (this.$store.getters.role != "SUPERADMIN") {
      //   var minDate = moment()
      //     .add(1, "days")
      //     .format("YYYY-MM-DD");
      //   rule += `|mindate:'${minDate}'`;
      // }
      return rule;
    },
  },
};
</script>
